export const CLEAR_ATTENDANCE_RECORDS = 'CLEAR_ATTENDANCE_RECORDS';

export const GET_ATTENDANCE_HISTORY_CALL = 'GET_ATTENDANCE_HISTORY_CALL';
export const GET_ATTENDANCE_HISTORY_DONE = 'GET_ATTENDANCE_HISTORY_DONE';
export const GET_ATTENDANCE_HISTORY_FAIL = 'GET_ATTENDANCE_HISTORY_FAIL';

export const DELETE_PUNCH_IN_RECORD_CALL = 'DELETE_PUNCH_IN_RECORD_CALL';
export const DELETE_PUNCH_IN_RECORD_DONE = 'DELETE_PUNCH_IN_RECORD_DONE';
export const DELETE_PUNCH_IN_RECORD_FAIL = 'DELETE_PUNCH_IN_RECORD_FAIL';

export const GET_PUNCH_IN_RECORDS_CALL = 'GET_PUNCH_IN_RECORDS_CALL';
export const GET_PUNCH_IN_RECORDS_DONE = 'GET_PUNCH_IN_RECORDS_DONE';
export const GET_PUNCH_IN_RECORDS_FAIL = 'GET_PUNCH_IN_RECORDS_FAIL';

export const PUT_PUNCH_IN_RECORD_CALL = 'PUT_PUNCH_IN_RECORD_CALL';
export const PUT_PUNCH_IN_RECORD_DONE = 'PUT_PUNCH_IN_RECORD_DONE';
export const PUT_PUNCH_IN_RECORD_FAIL = 'PUT_PUNCH_IN_RECORD_FAIL';
